<template>
  <div :class="pasoClass">
    <span :class="pasoBadge">{{ id }}</span>
    <span>{{ nombre }}</span>
  </div>
</template>

<script>
  export default {
    props: ['id', 'nombre', 'activo'],
    computed: {
      pasoClass: function() {
        return {'paso activo font-weight-bold': this.activo, 'paso': !this.activo};
      },
      pasoBadge: function() {
        return {'badge badge-success': this.activo, 'badge': !this.activo};
      }
    }
  }
</script>

<style lang="sass" scoped>
  .paso
    color: #757575
    &.activo
      color: #424242
</style>



// WEBPACK FOOTER //
// src/components/Paso.vue